import { gql } from '@apollo/client';
import { OrganizationCardUpdatedCacheHandlerParams } from 'types/cache.types';

// La sélection de la page équipe (`GET_USERS_OF_ORGANIZATION`) : un salarié sans carte n'a pas d'entité
// `OrganizationCard` en cache, c'est son `wallet` qu'il faut faire pointer sur la carte créée.
const USER_ORGANIZATION_CARD = gql`
    fragment UserOrganizationCard on User {
        wallet {
            organizationCard {
                _id
                state
            }
        }
    }
`;

export function organizationCardUpdatedCacheHandler({
    apolloClient,
    organizationCard,
}: OrganizationCardUpdatedCacheHandlerParams): void {
    const id = `User:${organizationCard.userId}`;
    const data = apolloClient.readFragment({ id, fragment: USER_ORGANIZATION_CARD });

    apolloClient.writeFragment({
        id,
        fragment: USER_ORGANIZATION_CARD,
        data: {
            wallet: { ...data?.wallet, organizationCard },
        },
    });
}
